import { PageController } from '@client/components/_core/layout/PageController';
import { ProductVersionContactTypeEdit } from '@client/components/products-v2/ProductVersionContactTypeEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit contact type',
        },
    },
    params: {
        parse({ contactTypeId }) {
            return {
                contactTypeId: BigInt(contactTypeId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ProductVersionContactTypeEdit action={['edit', Route.useParams().contactTypeId]} />
        </PageController>
    );
}
